import { Controller } from "stimulus"

export default class extends Controller {

  static targets = [ "residueType", "collectionUnits", "collectionFrequency" ]

  connect() {
    if (document.body.getAttribute("data-action").includes("new") || document.body.getAttribute("data-action").includes("edit")) {
      var cleave = new Cleave('.input-date', {
        date: true,
        datePattern: ['d', 'm', 'Y']
      })
    }
    if (document.body.getAttribute("data-action").includes("edit") || document.body.getAttribute("data-action").includes("update")) {
      if (this.collectionFrequencyTarget.value == "Pontual") {
        document.getElementById("collectionDateBlock").classList.remove("is-display-none")
      } else {
        document.getElementById("collectionDaysBlock").classList.remove("is-display-none")
      }
      if (this.residueTypeTarget.options[this.residueTypeTarget.selectedIndex].textContent == "Recicláveis") {
        document.getElementById("cooperativeBlock").classList.remove("is-display-none")
        document.getElementById("compostingBlock").classList.add("is-display-none")
      } else if (this.residueTypeTarget.options[this.residueTypeTarget.selectedIndex].textContent == "Orgânicos") {
        document.getElementById("destinyLandfillBlock").classList.add("is-display-none")
        document.getElementById("cooperativeBlock").classList.add("is-display-none")
        document.getElementById("compostingBlock").classList.remove("is-display-none")
      } else {
        document.getElementById("destinyLandfillBlock").classList.remove("is-display-none")
        document.getElementById("cooperativeBlock").classList.add("is-display-none")
      }
    }
  }

  // Change residue type and return collection units
  changeResidueType(event) {
    var collectionUnitsTarget = this.collectionUnitsTarget
    if (event.currentTarget.value == "") {
      collectionUnitsTarget.options.length = 1
    } else {
      fetch("/unidades-de-coleta/" + event.currentTarget.value).then(
        function(response) {
          return response.json().then(function(json) {
            collectionUnitsTarget.options.length = 1
            for (var i = 0; i < json.length; i++) {
              var option = document.createElement("option")
              option.appendChild(document.createTextNode(json[i]["name"]))
              option.value = json[i]["_id"]["$oid"]
              collectionUnitsTarget.appendChild(option)
            }
          })
        }
      )
      switch (event.target.selectedOptions[0].textContent) {
        case "Recicláveis":
          document.getElementById("destinyLandfillBlock").classList.add("is-display-none")
          document.getElementById("cooperativeBlock").classList.remove("is-display-none")
          document.getElementById("compostingBlock").classList.add("is-display-none")
          break;
        case "Orgânicos":
          document.getElementById("destinyLandfillBlock").classList.add("is-display-none")
          document.getElementById("compostingBlock").classList.remove("is-display-none")
          document.getElementById("cooperativeBlock").classList.add("is-display-none")
          break;
        case "Rejeitos":
          document.getElementById("destinyLandfillBlock").classList.remove("is-display-none")
        case "Eletroeletrônicos":
          document.getElementById("destinyLandfillBlock").classList.remove("is-display-none")
        default:
          document.getElementById("compostingBlock").classList.add("is-display-none")
          document.getElementById("cooperativeBlock").classList.add("is-display-none")
      }
    }
  }

  // Change collection frequency
  changeCollectionFrequency(event) {
    let collectionFrequency = event.currentTarget.value
    switch (collectionFrequency) {
      case "Pontual":
        document.getElementById("collectionDateBlock").classList.remove("is-display-none")
        document.getElementById("collectionDaysBlock").classList.add("is-display-none")
        break;
      case "Diário":
      case "Quinzenal":
      case "Mensal":
        document.getElementById("collectionDaysBlock").classList.remove("is-display-none")
        document.getElementById("collectionDateBlock").classList.add("is-display-none")
        break;
      default:
        document.getElementById("collectionDaysBlock").classList.add("is-display-none")
        document.getElementById("collectionDateBlock").classList.add("is-display-none")
    }
  }
}
